import { InjectionToken } from '@angular/core';

export interface InactivityConfig {
  inactivityTimeMs: number;
  warningTimeMs: number;
  enableMultiTabSync: boolean;
  monitoredEvents: string[];
}

export const INACTIVITY_CONFIG = new InjectionToken<InactivityConfig>('INACTIVITY_CONFIG');

export const DEFAULT_INACTIVITY_CONFIG: InactivityConfig = {
  inactivityTimeMs: 30 * 60 * 1000, // 30 minutos
  warningTimeMs: 60 * 1000, // 60 segundos
  enableMultiTabSync: true,
  monitoredEvents: [
    'mousedown',
    'mousemove', 
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ]
};